const Config = {
  TOKEN: 'token',
  USERINFO: 'userInfo',
  STAFFID: 'staffId',
  ORGANIZATIONINFO: 'organizationInfo',
  CURRENTORGID: 'current-org-id',
  MENUS: 'menus',
  AUTHS: 'auths',
  REMEBER_PHONE: 'remeber-phone',
  LOGINNAME: 'loginName',
  LOGIN_TIME: 'login-time',
  STAFF_TREE: 'staff-tree',
  REFRESH_TOKEN: 'refresh-token',
  PRIVACY_URL:
    process.env.NODE_ENV === 'production'
      ? 'http://pics.govicar.com/app/page/digitalDashboard_privacyPolicy.html'
      : 'http://pics.govicar.com/app/page/digitalDashboard_privacyPolicy.html',
  SERVER_URL:
    process.env.NODE_ENV === 'production'
      ? 'http://pics.govicar.com/app/page/digitalDashboard_userProtocol.html'
      : 'http://pics.govicar.com/app/page/digitalDashboard_userProtocol.html',
};

export default Config;
